(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   PRODUCTION JAVASCRIPT - VANILLA JS ONLY (NO JQUERY, NO EXTERNAL LIBS)
   ========================================================================== */

(function () {
  'use strict';

  function initMainProduct() {
    var sectionEl = document.querySelector('.ms-product-section');
    if (!sectionEl) return;

    var sectionId = sectionEl.dataset.sectionId;
    var formEl = document.getElementById('ms-product-form');
    var variantInput = document.getElementById('ms-variant-id-input');
    var atcBtn = document.getElementById('ms-add-to-cart-btn');
    var stickyBar = document.getElementById('ms-sticky-bar');
    var stickyBtn = document.getElementById('ms-sticky-submit-btn');
    var stickySelect = document.getElementById('ms-sticky-select');

    // 1. DELIVERY ESTIMATE CALCULATOR (Skips Weekends)
    var deliveryDateEl = document.getElementById('ms-delivery-arrival-date');
    var cutoffClockEl = document.getElementById('ms-cutoff-timer');
    var processingDays = parseInt(sectionEl.dataset.processingDays || '1', 10);
    var cutoffHour = parseInt(sectionEl.dataset.cutoffHour || '14', 10);

    function calculateDeliveryDate() {
      if (!deliveryDateEl) return;
      var now = new Date();
      var daysToAdd = processingDays + 2; // standard transit
      var current = new Date(now.getTime());

      // If past cutoff hour, add an extra day
      if (current.getHours() >= cutoffHour) {
        current.setDate(current.getDate() + 1);
      }

      var added = 0;
      while (added < daysToAdd) {
        current.setDate(current.getDate() + 1);
        var dayOfWeek = current.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          added++;
        }
      }

      var options = { weekday: 'short', month: 'short', day: 'numeric' };
      deliveryDateEl.textContent = current.toLocaleDateString('en-US', options);
    }
    calculateDeliveryDate();

    // Live Cutoff Countdown
    function updateCutoffCountdown() {
      if (!cutoffClockEl) return;
      var now = new Date();
      var target = new Date();
      target.setHours(cutoffHour, 0, 0, 0);
      if (now > target) {
        target.setDate(target.getDate() + 1);
      }
      var diffMs = target - now;
      var hours = Math.floor(diffMs / (1000 * 60 * 60));
      var mins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      cutoffClockEl.textContent = hours + 'h ' + mins + 'm';
    }
    updateCutoffCountdown();
    setInterval(updateCutoffCountdown, 60000);

    // 2. SALE COUNTDOWN TIMER (Metafield or Schema tied)
    var saleTimerEl = document.getElementById('ms-sale-timer');
    if (saleTimerEl && saleTimerEl.dataset.deadline) {
      var deadline = new Date(saleTimerEl.dataset.deadline).getTime();
      function updateSaleClock() {
        var now = new Date().getTime();
        var distance = deadline - now;
        if (distance < 0) {
          saleTimerEl.style.display = 'none';
          return;
        }
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        var dEl = document.getElementById('ms-cd-days');
        var hEl = document.getElementById('ms-cd-hours');
        var mEl = document.getElementById('ms-cd-mins');
        var sEl = document.getElementById('ms-cd-secs');

        if (dEl) dEl.textContent = String(days).padStart(2, '0');
        if (hEl) hEl.textContent = String(hours).padStart(2, '0');
        if (mEl) mEl.textContent = String(minutes).padStart(2, '0');
        if (sEl) sEl.textContent = String(seconds).padStart(2, '0');
      }
      updateSaleClock();
      setInterval(updateSaleClock, 1000);
    }

    // 3. CART RESERVATION TIMER
    var reservationEl = document.getElementById('ms-reservation-time');
    if (reservationEl) {
      var reserveSeconds = 600; // 10 minutes
      setInterval(function () {
        if (reserveSeconds <= 0) return;
        reserveSeconds--;
        var rMins = Math.floor(reserveSeconds / 60);
        var rSecs = reserveSeconds % 60;
        reservationEl.textContent = String(rMins).padStart(2, '0') + ':' + String(rSecs).padStart(2, '0');
      }, 1000);
    }

    // 4. RANDOM FLUX FOR LIVE VIEWERS & SOCIAL PROOF
    var viewersEl = document.getElementById('ms-viewer-count');
    if (viewersEl) {
      var minV = parseInt(viewersEl.dataset.min || '8', 10);
      var maxV = parseInt(viewersEl.dataset.max || '24', 10);
      setInterval(function () {
        var current = parseInt(viewersEl.textContent, 10) || minV;
        var change = Math.floor(Math.random() * 3) - 1; // -1, 0, or +1
        var next = Math.max(minV, Math.min(maxV, current + change));
        viewersEl.textContent = next;
      }, 8000);
    }

    // 5. STICKY ADD TO CART BAR (IntersectionObserver)
    if (atcBtn && stickyBar) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            stickyBar.classList.add('ms-visible');
            stickyBar.setAttribute('aria-hidden', 'false');
          } else {
            stickyBar.classList.remove('ms-visible');
            stickyBar.setAttribute('aria-hidden', 'true');
          }
        });
      }, { threshold: 0.1 });
      observer.observe(atcBtn);
    }

    // Sticky CTA triggers main form submit
    if (stickyBtn && formEl) {
      stickyBtn.addEventListener('click', function () {
        if (stickySelect && variantInput) {
          variantInput.value = stickySelect.value;
        }
        atcBtn.click();
      });
    }

    // 6. AJAX ADD TO CART (/cart/add.js)
    if (formEl) {
      formEl.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!atcBtn || atcBtn.disabled) return;

        var textSpan = atcBtn.querySelector('.ms-btn-text');
        var loaderSpan = atcBtn.querySelector('.ms-btn-loader');
        var successSpan = atcBtn.querySelector('.ms-btn-success');

        if (textSpan) textSpan.classList.add('ms-hidden');
        if (loaderSpan) loaderSpan.classList.remove('ms-hidden');
        atcBtn.disabled = true;

        var formData = new FormData(formEl);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
          .then(function (res) {
            return res.json();
          })
          .then(function (cartItem) {
            if (loaderSpan) loaderSpan.classList.add('ms-hidden');
            if (successSpan) successSpan.classList.remove('ms-hidden');

            // Dispatch global event for theme drawers / counters
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartItem, bubbles: true }));

            setTimeout(function () {
              if (successSpan) successSpan.classList.add('ms-hidden');
              if (textSpan) textSpan.classList.remove('ms-hidden');
              atcBtn.disabled = false;
            }, 2500);
          })
          .catch(function (err) {
            console.error('Cart add error:', err);
            if (loaderSpan) loaderSpan.classList.add('ms-hidden');
            if (textSpan) textSpan.classList.remove('ms-hidden');
            atcBtn.disabled = false;
          });
      });
    }

    // 7. THUMBNAIL GALLERY SWITCHING
    var thumbBtns = sectionEl.querySelectorAll('.ms-thumb-item');
    var mediaSlides = sectionEl.querySelectorAll('.ms-media-slide');
    var currentSlideNum = document.getElementById('ms-current-slide-num');

    thumbBtns.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () {
        thumbBtns.forEach(function (b) { b.classList.remove('ms-active'); b.setAttribute('aria-selected', 'false'); });
        mediaSlides.forEach(function (s) { s.classList.remove('ms-active'); });

        thumb.classList.add('ms-active');
        thumb.setAttribute('aria-selected', 'true');
        if (mediaSlides[idx]) {
          mediaSlides[idx].classList.add('ms-active');
        }
        if (currentSlideNum) {
          currentSlideNum.textContent = idx + 1;
        }
      });
    });

    // 8. IMAGE LIGHTBOX
    var lightbox = document.getElementById('ms-lightbox');
    var lightboxImg = document.getElementById('ms-lightbox-image');
    var lightboxClose = document.getElementById('ms-lightbox-close');

    sectionEl.querySelectorAll('.ms-lightbox-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var parentZoom = trigger.closest('.ms-zoom-container');
        if (parentZoom && lightbox && lightboxImg) {
          lightboxImg.src = parentZoom.dataset.zoomSrc;
          lightbox.style.display = 'flex';
        }
      });
    });

    if (lightboxClose && lightbox) {
      lightboxClose.addEventListener('click', function () {
        lightbox.style.display = 'none';
      });
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) lightbox.style.display = 'none';
      });
    }

    // 9. SIZE GUIDE MODAL
    var sizeOpen = document.getElementById('ms-open-size-guide');
    var sizeModal = document.getElementById('ms-size-modal');
    var sizeClose = document.getElementById('ms-size-close');

    if (sizeOpen && sizeModal) {
      sizeOpen.addEventListener('click', function () {
        sizeModal.style.display = 'flex';
      });
    }
    if (sizeClose && sizeModal) {
      sizeClose.addEventListener('click', function () {
        sizeModal.style.display = 'none';
      });
      sizeModal.addEventListener('click', function (e) {
        if (e.target === sizeModal) sizeModal.style.display = 'none';
      });
    }

    // 10. RECENT PURCHASE TOAST (Max 3/session)
    var toast = document.getElementById('ms-purchase-toast');
    var toastClose = document.getElementById('ms-toast-close');
    if (toast) {
      try {
        var toastShownCount = parseInt(sessionStorage.getItem('ms_toast_count') || '0', 10);
        if (toastShownCount < 3) {
          setTimeout(function () {
            toast.classList.add('ms-toast-show');
            sessionStorage.setItem('ms_toast_count', String(toastShownCount + 1));
            setTimeout(function () {
              toast.classList.remove('ms-toast-show');
            }, 6000);
          }, 4000);
        }
      } catch (e) {
        console.warn('Storage disabled');
      }

      if (toastClose) {
        toastClose.addEventListener('click', function () {
          toast.classList.remove('ms-toast-show');
        });
      }
    }

    // 11. EXIT-INTENT MODAL (Desktop mouseleave, mobile scroll-up trigger)
    var exitModal = document.getElementById('ms-exit-modal');
    var exitClose = document.getElementById('ms-exit-close');
    var copyBtn = document.getElementById('ms-copy-coupon');

    if (exitModal) {
      try {
        var hasSeenExit = sessionStorage.getItem('ms_seen_exit');
        if (!hasSeenExit) {
          var onMouseLeave = function (e) {
            if (e.clientY <= 10) {
              exitModal.style.display = 'flex';
              sessionStorage.setItem('ms_seen_exit', 'true');
              document.removeEventListener('mouseleave', onMouseLeave);
            }
          };
          document.addEventListener('mouseleave', onMouseLeave);
        }
      } catch (err) {}

      if (exitClose) {
        exitClose.addEventListener('click', function () {
          exitModal.style.display = 'none';
        });
      }
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          navigator.clipboard.writeText('SPECIAL10').then(function () {
            copyBtn.textContent = 'Copied!';
            setTimeout(function () { copyBtn.textContent = 'Copy Code'; }, 2000);
          });
        });
      }
    }

    // 12. QUANTITY STEPPER
    var qtyInput = sectionEl.querySelector('.ms-qty-input');
    var qtyMinus = sectionEl.querySelector('.ms-qty-minus');
    var qtyPlus = sectionEl.querySelector('.ms-qty-plus');

    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function () {
        var cur = parseInt(qtyInput.value, 10) || 1;
        if (cur > 1) qtyInput.value = cur - 1;
      });
      qtyPlus.addEventListener('click', function () {
        var cur = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = cur + 1;
      });
    }

    // 13. RECENTLY VIEWED (LocalStorage)
    try {
      var prodId = sectionEl.dataset.productId;
      if (prodId) {
        var history = JSON.parse(localStorage.getItem('ms_recent_pids') || '[]');
        if (!history.includes(prodId)) {
          history.unshift(prodId);
          if (history.length > 6) history.pop();
          localStorage.setItem('ms_recent_pids', JSON.stringify(history));
        }
      }
    } catch (err) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMainProduct);
  } else {
    initMainProduct();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
